/**
 * Vinyl record loader — spinning vinyl with the Pulse logo as the center label.
 * Use anywhere a generic loading state is needed.
 */
export default function VinylLoader({ size = 80, label = "" }) {
  const labelDiameter = size * 0.42; // % of vinyl that's the center label
  return (
    <div className="inline-flex flex-col items-center justify-center gap-3">
      <div
        className="vinyl-spin relative rounded-full"
        style={{
          width: size,
          height: size,
          background:
            "radial-gradient(circle at 50% 50%, #1a1a1d 0%, #0c0c0e 55%, #050506 100%)",
          boxShadow:
            "0 0 30px rgba(0,184,255,0.18), inset 0 0 0 1px rgba(255,255,255,0.04)",
        }}
        data-testid="vinyl-loader"
      >
        {/* concentric grooves */}
        {[0.92, 0.82, 0.72, 0.62, 0.52].map((scale, i) => (
          <div
            key={i}
            className="absolute rounded-full"
            style={{
              top: "50%",
              left: "50%",
              width: size * scale,
              height: size * scale,
              transform: "translate(-50%, -50%)",
              border: "1px solid rgba(255,255,255,0.04)",
            }}
          />
        ))}
        {/* highlight sheen */}
        <div
          className="absolute rounded-full pointer-events-none"
          style={{
            inset: 0,
            background:
              "conic-gradient(from 0deg, transparent 0deg, rgba(255,255,255,0.05) 30deg, transparent 60deg, transparent 360deg)",
          }}
        />
        {/* center label — the logo */}
        <div
          className="absolute rounded-full overflow-hidden"
          style={{
            top: "50%",
            left: "50%",
            width: labelDiameter,
            height: labelDiameter,
            transform: "translate(-50%, -50%)",
            background: "#08080A",
            boxShadow: "inset 0 0 0 1px rgba(0,184,255,0.25)",
          }}
        >
          <img
            src="/assets/logo-anim.webp"
            alt=""
            className="w-full h-full object-cover"
          />
        </div>
        {/* spindle dot */}
        <div
          className="absolute rounded-full"
          style={{
            top: "50%",
            left: "50%",
            width: 4,
            height: 4,
            transform: "translate(-50%, -50%)",
            background: "#00B8FF",
            boxShadow: "0 0 6px rgba(0,184,255,0.8)",
          }}
        />
      </div>
      {label && (
        <div className="label-mono text-zinc-500" style={{ fontSize: 10 }}>
          {label}
        </div>
      )}
    </div>
  );
}
